
export async function sendAnswer( data ) {

  let url = '/api/answers'
  console.log(data)
  return await $axios.post( url, data ).then( response => {
    console.log( response.data )
    return response.data
  }).catch( error => {
    console.log("error")
    console.log(error)
    return error
  })
}

export async function postQuestionOrder( examId, data ) {
  let url = '/api/exam/' + examId + '/questionorder'
  console.log(data)
  return await $axios.put( url, data ).then( response => {
    console.log( response.data )
    return response.data
  }).catch( error => {
    console.log("error")
    console.log(error)
    return error
  })
}

export async function postQuestion( data ) {
  let url = '/api/questions'
  console.log("postQuestion")
  console.log(data)
  return await $axios.post( url, data ).then( response => {
    console.log( response.data )
    return response.data
  }).catch( error => {
    console.log("error")
    console.log(error)
    return error
  })
}

export async function updateQuestion( questionId, data ) {
  let url = '/api/questions/' + questionId
  console.log("updateQuestion")
  console.log(data)
  return await $axios.put( url, data ).then( response => {
    console.log( response.data )
    return response.data
  }).catch( error => {
    console.log("error")
    console.log(error)
    return error
  })
}

export async function deleteQuestion( questionId ) {
    let url = '/api/questions/' + questionId
    console.log("deleteQuestion")
    return await $axios.delete( url ).then( response => {
        console.log( response.data )
        return response.data
    }).catch( error => {
        console.log("error")
        console.log(error)
        return error
    })
}